<template>
  <div id="dg__contact" ref="contact" v-if="!checkValueNll">
    <div class="icon-box text-center">
      <p class="icon t-[theme] t-[22]">&#xe761;</p>
      <p class="t-[#606266] t-[12]">客服</p>
    </div>
    <div class="content">
      <div class="t-[12] pb-[4] t-[#303133] mb-[6]" v-if="value.customerServicePhone"><span class="t-[#606266]"><i
            class="icon t-[16] mr-[4]">&#xe6d6;</i>固定电话</span><span class="t-[14] ml-[10]">{{
              value.customerServiceMobile }}</span>
        <div class="text-center pl-[45] t-[14]">{{ value.customerServicePhone }}</div>
      </div>
      <p class="t-[12] t-[#303133] mb-[10]" v-if="value.customerServiceTime"><span class="t-[#606266]"><i
            class="icon t-[16] mr-[4]">&#xe6d7;</i>服务时间</span><span class="t-[14] ml-[10]">{{ value.customerServiceTime
            }}</span> </p>
      <div class="flex justify-between pt-[10] border-t-[1] border-solid border-[#F0F0F0]">
        <div v-if="value.customerServiceWechatQrcode" class="text-center">
          <p><img :src="value.customerServiceWechatQrcode" class="img-code" alt="" /></p>
          <p class="pt-[4] t-[12] t-[#606266]">客服微信</p>
        </div>
        <div class="pr-[10] text-center" v-if="value.wechatPublicQrcode">
          <p><img :src="value.wechatPublicQrcode" class="img-code" alt="" /></p>
          <p class="pt-[4] t-[12] t-[#606266]">微信公众号</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: "dg-contact",
  props: {
    top: String,
    right: String,

    value: {
      type: Object,
      default: () => {
        return {
          customerServiceMobile: config.contact.wxcode ? config.contact.wxcode : "18106099208", // 服务电话
          customerServicePhone: config.contact.phone ? config.contact.phone : "400-816-1767", // 服务电话
          customerServiceTime: "工作日 9:00-18:00", // 服务时间
          customerServiceWechatQrcode: new URL(`../assets/img/city/${process.config.city}/ke_fu.png`, import.meta.url).href, //客服二维码
          wechatPublicQrcode: ['ji-nan', 'fu-yang'].indexOf(config.city) == -1 ? new URL(`../assets/img/city/${process.config.city}/gzh.png`, import.meta.url).href : ''// 公众号 
        };
      }
    },
    href: String
  },
  computed: {
    checkValueNll() {
      if (this.value && Object.keys(this.value).length == 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    if (this.top) {
      this.$refs["contact"].style.top = this.top;
    }
    if (this.right) {
      this.$refs["contact"].style.right = this.right;
    }
  }
};
</script>

<style scoped lang="less">
// @import '~@/assets/css/var.less';

#dg__contact {
  position: fixed;
  top: 25%;
  right: 20px;
  color: #303133;
  z-index: 10;

  &:hover .content {
    display: block;
  }

  .icon-box {
    width: 54px;
    height: 54px;
    background: #fff;
    border-radius: 100px;
    cursor: pointer;
    padding: 8px;
  }

  .content {
    background: #fff;
    padding: 16px;
    min-width: 238px;
    position: absolute;
    top: 0;
    right: 65px;
    border-radius: 4px;
    box-shadow: 0px 2px 6px 0px rgba(197, 197, 197, 0.22);
    display: none;
    background: linear-gradient(180deg, #F3F3F6 0%, #FFFFFF 100%);
  }

  .img-code {
    width: 90px;
    height: 90px;
  }
}
</style>
